import { reduxStore } from 'reduxStore'

import { getLayerFromTitleID } from 'api/utils'

export const sanitiseProfileName = (name: string) => {
  if (!name) {
    return undefined
  }

  const sanitisedName = name
    .replace(/[^*a-zA-Z0-9_-]/g, ' ')
    .replace(/ +/g, ' ')
    .trim()

  // console.debug('profile - sanitiseProfileName - sanitised name', sanitisedName)

  return sanitisedName
}

export const getIdFromProfileName = (name: string) => {
  const sanitisedName = sanitiseProfileName(name)

  const idFromName = sanitisedName
    ?.toLowerCase()
    .replace(/ +/g, '-')
    .replace(/-+/g, '-')

  // console.debug('profile - getIdFromProfileName - id from name', idFromName)

  return idFromName
}

export const layerValidInCurrentProfile = (titleid: string, profile?: string) => {
  // console.debug('profile - layerValidInCurrentProfile', titleid, profile)

  const reduxState = reduxStore.getState()

  const { currentProfile, profiles } = reduxState

  // Allow the user to provide a profile
  const currentProfileId = profile || currentProfile

  // If no current profile is set, then assume that all layers are valid
  if (!currentProfileId) {
    return true
  }

  // Check if the layer is in the current profile
  const profileCurrent = profiles[currentProfileId]
  if (profileCurrent?.layers?.includes(titleid)) {
    return true
  }

  // Any layers that have 'profiles=*' defined are valid in any profile
  const profileWildcard = profiles['*']
  if (profileWildcard?.layers?.includes(titleid)) {
    return true
  }

  const layerConf = getLayerFromTitleID(titleid)

  // Internal layers like annotation, currenttarget, highlight and whatshere are valid in any profile
  const isInternalLayer = layerConf?.groupid === 'pozigeneral'
  if (isInternalLayer) {
    return true
  }

  return false
}
